import React from "react";

interface ListHeaderProps {
  children?: React.ReactNode;
  "data-testid"?: string;
}

export const ListHeader: React.FC<ListHeaderProps> = ({
  children,
  "data-testid": testid,
}) => {
  return (
    <div data-testid={testid} className="mb-4 flex justify-between">
      {children}
    </div>
  );
};
